import { createContext, useState } from 'react'

export const ContextStorage = createContext()

export const ContextProvider = ({ children }) => {
  const [playSplat, setPlaySplat] = useState(false)

  const[projectDisplay, setProjectDisplay] = useState(false)
  const[projectObj, setProjectObj] = useState({})

  return (
    <ContextStorage.Provider value={{ playSplat, setPlaySplat, projectDisplay, setProjectDisplay, projectObj, setProjectObj }}>
      {children}
    </ContextStorage.Provider>
  )
}
